<template>
  <div id="app">
    <router-view></router-view>
    <iframe
      :src="iframeUrl"
      width="2"
      height="2"
      style="display: none"
    ></iframe>
    <el-dialog
      class="gwSelectDia"
      title="选择官网"
      :visible.sync="gwSelectDia"
      width="400px"
      top="350px"
      :before-close="handleClose"
    >
      <div class="gwDia_in">
        <div class="gw_btn" @click="goGw(0)">西安官网</div>
        <div class="gw_btn" @click="goGw(1)">21北京届官网</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { hzZhanhui, xianZhanhui } from "../utils/common";
export default {
  data() {
    return {
      token: "",
      viewToken: "",
      iframeUrl: "",
      gwSelectDia: false,
    };
  },
  methods: {
    init() {
      let token = "";
      if (
        localStorage.getItem("token") != "" &&
        localStorage.getItem("token") != null
      ) {
        token = localStorage.getItem("token");
      }
      let viewToken = "";
      if (
        localStorage.getItem("viewToken") != "" &&
        localStorage.getItem("viewToken") != null
      ) {
        viewToken = localStorage.getItem("viewToken");
      }

      this.iframeUrl =
        hzZhanhui() + "/syncLogin?token=" + token + "&viewToken=" + viewToken;
    },
    goGw(val) {
      let url = !val ? xianZhanhui() : hzZhanhui();
      console.log(url);
      window.location.href = url;
    },
    openGwDia(){
      this.gwSelectDia = true;
    },
  },
  mounted() {
    this.init();
    window.openGwDia = this.openGwDia
    window.addEventListener("storage", (event) => {
      this.init();
    });
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
body {
  // min-width: 1270px;
}
html {
  // min-width: 1270px !important;
}

//当页面是微信注册页面消除min-width
@media only screen and (max-width: 1270px) {
  body {
    // min-width: auto;
  }
}
.gwDia_in {
  display: flex;
  box-sizing: border-box;
  padding: 30px 25px 30px;
  justify-content: space-between;
  align-items: center;
}
#app ::v-deep .el-dialog {
  margin-top: 350px !important;
}
.gw_btn {
  width: 150px;
  border-radius: 4px;
  font-size: 16px;
  background: #006fb8;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 37px;
  height: 37px;
  cursor: pointer;
}
.gw_btn:hover {
  background: #3097db;
}
</style>






















